// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__AFTam","heading":"LearnWin_heading__A9QK0","subheading":"LearnWin_subheading__KnpEj","grid":"LearnWin_grid__BEJii","card":"LearnWin_card__SHvAi"};